<template>
	<div class="slash-move" :style="`--mover-width: ${aWidth}px;`">
		<Slash v-bind="$attrs" class="mover" />
	</div>
</template>

<script>
import Slash from './Slash.vue'

export default {
	name: 'SlashMove',
	components: {
		Slash,
	},
	computed: {
		aWidth() {
			return this.$attrs.height / 0.65
		},
	}
}
</script>

<style scoped lang="scss">
.slash-move {
	height: 100%;
	width: 100%;
	display: grid;
	place-items: flex-start flex-end;
	position: relative;
	overflow: hidden;

	.mover {
		transition: all 200ms ease-out;
		position: absolute;
		left: 0;
		will-change: left;
		display: block;
		height: 100%;
		overflow: hidden;
	}

	&:hover {
		.mover {
			left: calc(100% - var(--mover-width));
		}
	}
}
</style>
